import { actionCreators as contentActionCreators, getContentChildNodes } from "Areas/Documents/content";
import { actionCreators as contentUploadActionCreators } from "Areas/Documents/contentUpload";
import { getAllUserContentFiles, getSelectedFileId, getSelectedFolderId, getUserContentFiles, getUserContentFolders } from "Areas/Documents/contentUpload/redux/selectors";
import { actionCreators as docActionCreators, getInnerObjectsSelectedIds } from "Areas/Documents/documentDetails";
import { DOCUMENT_TYPE } from "Common/dictionaries/documentType";
import { Permissions, security } from "Common/permissions";
import { connect } from "react-redux";
import { actionCreators, getActiveDocumentId, getActiveDocumentType, getContentModeTab, getNavigationObjects, getObjects, getObjectsInProgress } from "../redux";
import TabNavigationContent from "./tabNavigationContent";
const canEditDocuments = security.isAllowed([Permissions.DocumentsEdit]);
const mapStateToProps = (state) => ({
    selectedFolderId: getSelectedFolderId(state),
    selectedFileId: getSelectedFileId(state),
    folders: getUserContentFolders(state),
    files: getUserContentFiles(state),
    allFiles: getAllUserContentFiles(state),
    documentType: getActiveDocumentType(state),
    inProgress: getObjectsInProgress(state),
    navigationObjects: getNavigationObjects(state),
    documentObjects: getObjects(state),
    selectedIds: getInnerObjectsSelectedIds(state),
    activeDocumentId: getActiveDocumentId(state),
    contentModeTab: getContentModeTab(state),
    contentChildren: getContentChildNodes(state),
    canEditDocuments
});
const mapDispatchToProps = (dispatch) => ({
    onInitialized: () => dispatch(actionCreators.getObjects()),
    onSelectNavigationObject: (documentId, id) => dispatch(docActionCreators.setInnerObjectsSelectedIds([id], documentId, DOCUMENT_TYPE.CONTENT)),
    onSelectNavigationObjects: (documentId, ids) => dispatch(docActionCreators.setInnerObjectsSelectedIds(ids, documentId, DOCUMENT_TYPE.CONTENT)),
    onSelectContentModeTab: (contentModeTab) => {
        dispatch(actionCreators.setContentModeTab(contentModeTab));
    },
    onSaveFolder: (folder, files) => {
        dispatch(contentUploadActionCreators.saveFolder(folder, files));
    },
    onOpenFolderCreatorPanel: (documentId) => {
        dispatch(contentUploadActionCreators.setCreateNewFolder(documentId));
    },
    onOpenFolderEditorPanel: (documentId) => {
        dispatch(contentUploadActionCreators.setEditFolder(documentId));
    },
    onDeleteFolder: (folderId, documentId) => {
        dispatch(contentUploadActionCreators.deleteFolder(folderId, documentId));
    },
    onSelectFolder: (folderId, documentId) => {
        dispatch(contentUploadActionCreators.setFolderId(folderId, documentId));
    },
    onSelectFile: (folderId, documentId, fileId) => {
        dispatch(contentUploadActionCreators.setFolderId(folderId, documentId));
        dispatch(contentUploadActionCreators.setFileId(folderId, documentId, fileId));
    },
    onLoadFiles: (folderId, documentId) => {
        dispatch(contentUploadActionCreators.getFiles(folderId, documentId));
    },
    onLoadContentChildren: (documentId, nodeId) => {
        dispatch(contentActionCreators.getContentChildren(documentId, nodeId));
    }
});
export default connect(mapStateToProps, mapDispatchToProps)(TabNavigationContent);
